
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sam",
      function () {
        return require("private-next-pages/sam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sam"])
      });
    }
  